import { DownCaret } from "@/frontend/SVGs/DownCaret";
import { RightCaret } from "@/frontend/SVGs/RightCaret";

export function CollapseButton(props: { showElement: boolean, setShowElement: (show: boolean) => void, title?: string, size?: 'sm' | 'lg' }) {
  const { showElement, setShowElement, title, size = 'lg' } = props;

  const expandTitle = title ? `Expand ${title}` : 'Expand';
  const collapseTitle = title ? `Collapse ${title}` : 'Collapse';

  return (
    <>
      {!showElement && <button
        onClick={() => setShowElement(true)}
        title={expandTitle}
        className='btn p-0'
      >
        <RightCaret size={size} />
      </button>}
      {showElement && <button
        onClick={() => setShowElement(false)}
        title={collapseTitle}
        className='btn p-0'
      >
        <DownCaret size={size} />
      </button>}
    </>
  );
}
